



import AboutUs from "./AboutUs"; // ✅ Import your new page
import Services from "./Services";
// import Portfolio from "./Portfolio";
import Contact from "./Contact";
// import Management from "./Management";
// import { Home } from "lucide-react";
import HomePage from "./HomePage";
// import WhyChoose from "./WhyChoose";


export default function LandingPage() {
return (
  <div>
    <HomePage />
    <AboutUs includeHeaderOffset={false} />
    <Services />
    {/* <Portfolio /> */}
    {/* <Management /> */}

    <Contact />
  </div>
);
}